export default __webpack_public_path__ + "static/tractor-and-field-411066d6f9739b51347c53bc27f8670c.svg";